import { fetchClient } from '@/util/fetchClient';

export interface ConfirmAccountDetailsPayload {
  firstName?: string;
  lastName?: string;
  email?: string;
  npiNumber?: string;
  streetAddress?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  internationalAddress?: string;
  learnAboutAutoPayments?: boolean;
  skipConfirmTimestamp?: boolean;
}

/**
 * Confirm account details for the current user.
 *
 * Calls PATCH /v2/users/me/confirm-account-details to mark the user
 * as having confirmed their account details.
 */
export async function confirmAccountDetails(payload?: ConfirmAccountDetailsPayload) {
  const { data } = await fetchClient.PATCH('/v2/users/me/confirm-account-details', {
    body: payload ?? {},
  });

  return data;
}
